var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMalning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3 1 C 1.90625 1 1 1.90625 1 3 L 1 15 C 1 16.09375 1.90625 17 3 17 L 42 17 C 43.09375 17 44 16.09375 44 15 L 44 10 L 45 10 L 45 19.1875 L 22.78125 24.03125 C 22.328125 24.132813 22.003906 24.535156 22 25 L 22 29 L 20 29 C 18.90625 29 18 29.90625 18 31 L 18 47 C 18 48.09375 18.90625 49 20 49 L 26 49 C 27.09375 49 28 48.09375 28 47 L 28 31 C 28 29.90625 27.09375 29 26 29 L 24 29 L 24 25.8125 L 46.21875 20.96875 C 46.671875 20.867188 46.996094 20.464844 47 20 L 47 9 C 47 8.449219 46.550781 8 46 8 L 44 8 L 44 3 C 44 1.90625 43.09375 1 42 1 Z M 3 3 L 42 3 L 42 8.6875 C 41.941406 8.882813 41.941406 9.085938 42 9.28125 L 42 15 L 3 15 Z M 20 31 L 26 31 L 26 47 L 20 47 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalning);
export default __webpack_public_path__ + "static/media/malning.a5bc650d.svg";
export { ForwardRef as ReactComponent };